export class DefaultEndPointer {
  // liveEndpoint = 'https://test-api.nsiainsurance.com/v1/api/';
  liveEndpoint = 'https://live-api.nsiainsurance.com/v1/api/';
  // liveEndpoint = 'http://localhost:45340/v1/api/';
  constructor() {}
}
